'use client';

// Suporte v2 · emoji-rating (21st.dev jatin-yadav05/emoji-rating) adaptado pt-BR.
// Labels: Péssimo / Ruim / Ok / Bom / Incrível (1-5). onChange chama a action de feedback.

import { useState } from 'react';

import { cn } from '@/lib/utils';

interface RatingInteractionProps {
  onChange?: (rating: number) => void;
  className?: string;
}

const ratingData = [
  {
    emoji: '😔',
    label: 'Péssimo',
    color: 'from-red-400 to-red-500',
    shadowColor: 'shadow-red-500/30',
  },
  {
    emoji: '😕',
    label: 'Ruim',
    color: 'from-orange-400 to-orange-500',
    shadowColor: 'shadow-orange-500/30',
  },
  {
    emoji: '😐',
    label: 'Ok',
    color: 'from-yellow-400 to-yellow-500',
    shadowColor: 'shadow-yellow-500/30',
  },
  {
    emoji: '🙂',
    label: 'Bom',
    color: 'from-lime-400 to-lime-500',
    shadowColor: 'shadow-lime-500/30',
  },
  {
    emoji: '😍',
    label: 'Incrível',
    color: 'from-emerald-400 to-emerald-500',
    shadowColor: 'shadow-emerald-500/30',
  },
];

export function RatingInteraction({ onChange, className }: RatingInteractionProps) {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);

  const handleClick = (value: number) => {
    setRating(value);
    onChange?.(value);
  };

  const displayRating = hoverRating || rating;

  return (
    <div className={cn('flex flex-col items-center gap-6', className)}>
      <div className="flex items-center gap-3">
        {ratingData.map((item, i) => {
          const value = i + 1;
          const isActive = value <= displayRating;
          return (
            <button
              key={value}
              onClick={() => handleClick(value)}
              onMouseEnter={() => setHoverRating(value)}
              onMouseLeave={() => setHoverRating(0)}
              className="group relative focus:outline-none"
              aria-label={`Avaliar ${value}: ${item.label}`}
            >
              <div
                className={cn(
                  'relative flex h-14 w-14 items-center justify-center rounded-2xl transition-all duration-300 ease-out',
                  isActive ? 'scale-110' : 'scale-100 group-hover:scale-105',
                )}
              >
                <span
                  className={cn(
                    'text-3xl transition-all duration-300 ease-out select-none',
                    isActive
                      ? 'drop-shadow-lg grayscale-0'
                      : 'opacity-40 grayscale group-hover:opacity-70 group-hover:grayscale-[0.3]',
                  )}
                >
                  {item.emoji}
                </span>
              </div>
            </button>
          );
        })}
      </div>
      <div className="relative h-7 w-32">
        <div
          className={cn(
            'absolute inset-0 flex items-center justify-center transition-all duration-300 ease-out',
            displayRating > 0 ? 'scale-95 opacity-0 blur-md' : 'blur-0 scale-100 opacity-100',
          )}
        >
          <span className="text-muted-foreground text-sm font-medium whitespace-nowrap">
            Avalie o atendimento
          </span>
        </div>
        {ratingData.map((item, i) => (
          <div
            key={i}
            className={cn(
              'absolute inset-0 flex items-center justify-center transition-all duration-300 ease-out',
              displayRating === i + 1
                ? 'blur-0 scale-100 opacity-100'
                : 'scale-105 opacity-0 blur-md',
            )}
          >
            <span className="text-foreground text-sm font-semibold tracking-wide">
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
